import file from "@/views/oss/file/fileDataProvider";

export default {
    namespaced: true,
    modules: {
        file
    },
}
